import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import Spinner from 'common/Spinner';

import { postLoginV2SamlStep3 } from 'services/authentication/SAMLV2';

import { checkAuthV2StatusThunk } from 'store/auth/slice';

import messages from '../messages';

type SAMLStatus = 'SUCCESS' | 'IN_PROGRESS' | 'ERROR';

enum ERROR_REASON {
  NO_SUCH_USER = 'NO_SUCH_USER',
  MULTIPLE_USERS = 'MULTIPLE_USERS',
}

interface SAMLPollResponse {
  status: SAMLStatus;
  errorReason?: ERROR_REASON;
}

const PollSAML = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState<ERROR_REASON | undefined>(undefined);
  const [polling, setPolling] = useState(true);
  const { formatMessage } = useIntl();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const pollSAML = async () => {
      try {
        const response = await postLoginV2SamlStep3();
        const data = response.data as SAMLPollResponse;

        // eslint-disable-next-line default-case
        switch (data.status) {
          case 'SUCCESS':
            setPolling(false);
            dispatch(checkAuthV2StatusThunk());
            break;
          case 'IN_PROGRESS':
            // Continue polling every second
            timeoutId = setTimeout(pollSAML, 1000);
            break;
          case 'ERROR':
            setPolling(false);
            setError(data?.errorReason);
            break;
        }
      } catch (err) {
        setPolling(false);
        setError(err?.data?.errorReason);
        console.error('SAML polling error:', err);
      }
    };

    if (polling) {
      pollSAML();
    }

    // Cleanup timeout on unmount
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [dispatch, polling]);

  if (error) {
    return <div className="text-danger">{formatMessage(messages[error])}</div>;
  }

  return <div>{polling ? <Spinner /> : null}</div>;
};

export default PollSAML;
